import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { Link as AriaLink } from "react-aria-components";
import { icon } from "../icon.css.js";
import { link, linkContent, text } from "./Link.css.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BaseLink = (t0, ref) => {
  const $ = _c(32);
  let LeadingIcon;
  let TrailingIcon;
  let children;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      hierarchy: t1,
      size: t2,
      children,
      trailingIcon: TrailingIcon,
      leadingIcon: LeadingIcon,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = LeadingIcon;
    $[2] = TrailingIcon;
    $[3] = children;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
  } else {
    LeadingIcon = $[1];
    TrailingIcon = $[2];
    children = $[3];
    props = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  const hierarchy = t1 === undefined ? "primary" : t1;
  const size = t2 === undefined ? "m" : t2;
  let t3;
  if ($[7] !== hierarchy) {
    t3 = link({
      hierarchy
    });
    $[7] = hierarchy;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== size) {
    t4 = linkContent({
      size
    });
    $[9] = size;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== LeadingIcon || $[12] !== size) {
    t5 = LeadingIcon && /*#__PURE__*/_jsx(LeadingIcon, {
      className: icon({
        size
      })
    });
    $[11] = LeadingIcon;
    $[12] = size;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== size) {
    t6 = text({
      size
    });
    $[14] = size;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== children || $[17] !== t6) {
    t7 = /*#__PURE__*/_jsx("span", {
      className: t6,
      children: children
    });
    $[16] = children;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== TrailingIcon || $[20] !== size) {
    t8 = TrailingIcon && /*#__PURE__*/_jsx(TrailingIcon, {
      className: icon({
        size
      })
    });
    $[19] = TrailingIcon;
    $[20] = size;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t4 || $[23] !== t5 || $[24] !== t7 || $[25] !== t8) {
    t9 = /*#__PURE__*/_jsxs("div", {
      className: t4,
      children: [t5, t7, t8]
    });
    $[22] = t4;
    $[23] = t5;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== props || $[28] !== ref || $[29] !== t3 || $[30] !== t9) {
    t10 = /*#__PURE__*/_jsx(AriaLink, {
      ...props,
      className: t3,
      ref: ref,
      children: t9
    });
    $[27] = props;
    $[28] = ref;
    $[29] = t3;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  return t10;
};
export const Link = /*#__PURE__*/React.forwardRef(BaseLink);
//# sourceMappingURL=Link.js.map